import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import CustomQuoteInfoComponent from "./CustomQuoteInfoComponent";

const PECustomQuoteInfoComponent = (props) => (
  <CustomQuoteInfoComponent {...props} />
);

PECustomQuoteInfoComponent.propTypes = {
  submissionVM: PropTypes.shape({
    value: PropTypes.shape({
      isBundle_ML: PropTypes.bool,
    }),
  }).isRequired,
};

export default PECustomQuoteInfoComponent;
